<mat-chip
  class="badge tw-capitalize"
  [class.badge-green]="
    billingUtils.isActive(subscription) || billingUtils.isTrial(subscription)
  "
  [class.badge-red]="
    billingUtils.isPaused(subscription) ||
    billingUtils.isCancelled(subscription)
  "
>
  {{
    subscription.status === 'non_renewing'
      ? 'active'
      : subscription.status === 'in_trial'
        ? 'trial'
        : subscription.status
  }}
</mat-chip>
